export const BASE_URL = 'https://test-01-auth-pf-sso.blcloud.jp';

export const WS_URL = 'ws://test-01-auth-pf-sso.blcloud.jp/ws';